export default function resetPersonSelection({
    setNameSearch, setShowBuscar, setIsFocused,
    setCastellerSelected, setCaixaSelected, setNextChangeFromSuggestion,
}) {
    setNameSearch('');
    setShowBuscar(false);
    setIsFocused(false);
    setCastellerSelected(-1);
    setCaixaSelected(-1);
    setNextChangeFromSuggestion(false);
}
